import React, { useEffect, useState } from "react";
import clone from "lodash.clonedeep";
import { KONTUR_FIELDS, REQUIRED_FIELDS, TYPE_KONTUR_FOCUS } from './constants';
import { Modal } from "react-bootstrap";
import TableSheets from "./TableSheets";

import './style.scss';

const ClientImportExcelModal = ({event, sheets, roles, participationTypes, isModalVisible, onClose, registrationFields = [], onDone}) => {
    const [fields, setFields] = useState(clone(REQUIRED_FIELDS));
    
    useEffect(() => {
        if (!registrationFields?.length) return;
        
        const mappedFields = registrationFields.reduce((acc, {field}) => {
            if (field.type === TYPE_KONTUR_FOCUS) {
                acc = [...acc, ...clone(KONTUR_FIELDS)];
            } else {
                acc.push(field);
            }
            
            return acc;
        }, clone(fields));

        setFields(mappedFields);
    }, [registrationFields]);
    
    return (
        <Modal
            className="import-excel-modal"
            show={isModalVisible}
            onHide={onClose}
        >
            <TableSheets
                fields={fields}
                sheets={sheets}
                event={event}
                roles={roles}
                participationTypes={participationTypes}
                onDone={onDone}
                onClose={onClose}
            />
        </Modal>
    );
};
 
export default ClientImportExcelModal;
